/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N0, N30A, N400A, N800, P400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { NowLocation } from '../../../../utils/constants/schedule';
import { WEEK_DAY_COUNT } from '../constants';

const DAY_SIZE = 8 * 2.5;
const DAY_MARGIN = 8;
const STRIPE_WIDTH = 8 / 4;
export const WEEK_MIN_HEIGHT = 8 * 15.75;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	boxSizing: 'border-box',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${WEEK_MIN_HEIGHT}px`,
	paddingBottom: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	paddingTop: `${2 * DAY_MARGIN + DAY_SIZE}px`,
	position: 'relative',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Grid = styled.div({
	display: 'flex',
	height: 'inherit',
	left: 0,
	position: 'absolute',
	top: 0,
	width: 'inherit',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Cell = styled.div({
	height: '100%',
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${100 / WEEK_DAY_COUNT}%`,
	borderBottom: `1px solid ${token('color.border', N30A)}`,
	borderRight: `1px solid ${token('color.border', N30A)}`,
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Day = styled.h6<{
	nowLocation: NowLocation;
	isLong: boolean;
}>`
	align-items: center;
	border-radius: ${DAY_SIZE}px;
	display: flex;
	height: ${DAY_SIZE}px;
	justify-content: center;
	left: ${token('space.100', '8px')};
	margin: 0;
	min-width: ${DAY_SIZE}px;
	padding: 0px;
	position: absolute;
	top: ${token('space.100', '8px')};

	${({ isLong }) =>
		isLong &&
		`
    padding: 0 ${token('space.050', '4px')};
    `}

	${({ nowLocation }) => {
		switch (nowLocation) {
			case NowLocation.Before:
				return `
          color: ${token('color.text.subtle', N800)};
        `;
			case NowLocation.After:
				return `
          color: ${token('color.text.disabled', N400A)};
        `;
			case NowLocation.InRange:
				return `
          color: ${token('color.text.inverse', N0)};
          background-color: ${token('color.background.neutral.bold', N800)};
        `;
		}
	}}
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Stripe = styled.div<{
	startEpoch: number;
	nowEpoch: number;
	endEpoch: number;
}>`
	background-color: ${token('color.background.accent.purple.subtle', P400)};
	height: 100%;
	position: absolute;
	top: 0;
	width: ${STRIPE_WIDTH}px;
	z-index: 2;

	${({ nowEpoch, endEpoch, startEpoch }) => {
		const ratio = (nowEpoch - startEpoch) / (endEpoch - startEpoch);
		const halfWidth = STRIPE_WIDTH / 2;

		return `left: calc((100%  * ${ratio}) - ${halfWidth}px);`;
	}};
`;
